import Cookies from 'js-cookie';

class AdfCookieBar
{
    constructor ( cookieBar )
    {

        this.barContainer       = cookieBar;
        this.innerContainer     = this.barContainer.querySelector( '.inner-container' );
        this.delayBeforeShowing = 3000; // in millliseconds


        const cookieAlreadySet = this.checkForCookie();

        if ( cookieAlreadySet )
        {
            return;
        }

        this.bindEvents();


        setTimeout( () =>
        {
            this.showBar();

        }, this.delayBeforeShowing );
    }

    bindEvents ()
    {
        this.btnAccept = this.barContainer.querySelector( '.btn-agreee-to-cookie' );

        this.btnAccept.addEventListener( 'click', ( e ) =>
        {
            this.saveCookie();
            this.hideBar();
        } );


        // keyboard nav trap
        this.btnAccept.addEventListener( 'keydown', ( event ) =>
        {

            if ( event.which === 9 )
            {
                event.preventDefault();
                this.innerContainer.focus();
            }
        } )
    }

    showBar ()
    {
        this.barContainer.classList.add( 'open' );
        document.body.classList.add( 'blurred' );


        this.innerContainer.setAttribute( 'tabindex', 0 );
        this.innerContainer.focus();

    }

    hideBar ()
    {
        this.barContainer.classList.remove( 'open' );
        document.body.classList.remove( 'blurred' );

        this.barContainer.removeAttribute( 'tabindex' );

    }


    checkForCookie ()
    {
        const existingAcceptedCookie = Cookies.get( 'adfAcceptedCookies' );

        // console.log( '[AdfCookieBar] is checking for cookie', existingAcceptedCookie );

        return existingAcceptedCookie;
    }

    saveCookie ()
    {

        Cookies.set( 'adfAcceptedCookies', true, { expires : 300 } );
    }


}


const cookieBars = document.querySelectorAll( '.cookie-bar' );
if ( cookieBars )
{
    Array.from( cookieBars ).forEach( cB => new AdfCookieBar( cB ) );
}
